import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";

import classNames from "classnames/bind";
import styles from "./Layout.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { IoSettings, IoNewspaperOutline } from "react-icons/io5";
import { TbMessageReport } from "react-icons/tb";
import { MdOutlinePolicy } from "react-icons/md";
import { GrDocumentPerformance } from "react-icons/gr";
import { AiOutlineMail, AiOutlineProduct } from "react-icons/ai";

import { ScrollToTop } from "../ScrollToTop/ScrollToTop";
import Login from "../../pages/Login";
import { getLoginInfo } from "../../apis";

const cx = classNames.bind(styles);

const list = [
  {
    id: 1,
    title: "서비스 관리",
    path: [
      {
        id: 1,
        title: "회사 정보 관리",
        path: "/service-settings",
        icon: <IoSettings className={cx("icon")} />,
      },
      {
        id: 2,
        title: "회사 성과 관리",
        path: "/service-performance",
        icon: <GrDocumentPerformance className={cx("icon")} />,
      },
    ],
  },
  {
    id: 2,
    title: "약관 및 정책 관리",
    path: [
      {
        id: 1,
        title: "개인정보 처리 방침",
        path: "/privacy-policy",
        icon: <MdOutlinePolicy className={cx("icon")} />,
      },
      {
        id: 2,
        title: "이메일 수집 거부",
        path: "/email-collection-refusal",
        icon: <AiOutlineMail className={cx("icon")} />,
      },
    ],
  },
  {
    id: 3,
    title: "소식 관리",
    path: "/news",
    icon: <IoNewspaperOutline className={cx("icon")} />,
  },
  {
    id: 4,
    title: "문의 관리",
    path: "/inquiry",
    icon: <TbMessageReport className={cx("icon")} />,
  },
  {
    id: 5,
    title: "품목 관리",
    path: "/products",
    icon: <AiOutlineProduct className={cx("icon")} />,
  },
];

export default function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTitle, setCurrentTitle] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    // (1) 토큰 없을 때 로그인 페이지로 이동
    // if (location.pathname !== "/" && !token) {
    //   navigate("/");
    //   return;
    // }

    // (2) 토큰이 있다면 사용자 정보 가져오기
    if (token) {
      getLoginInfo()
        .then((res) => {
          setUser(res.data.user);
        })
        .catch((err) => {
          console.error("❌ 로그인 정보 불러오기 실패:", err);
          localStorage.removeItem("token");
          navigate("/");
        });
    }

    // ✅ (3) 현재 페이지 타이틀 설정 로직 수정
    let matchedTitle = "";

    list.forEach((item) => {
      if (Array.isArray(item.path)) {
        // 하위 메뉴 배열일 경우
        const sub = item.path.find((subItem) =>
          location.pathname.startsWith(subItem.path)
        );
        if (sub) {
          matchedTitle = sub.title; // 하위 메뉴 제목 표시
        }
      } else if (location.pathname.startsWith(item.path)) {
        // 단일 path일 경우
        matchedTitle = item.title;
      }
    });

    setCurrentTitle(matchedTitle);
  }, [location, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    alert("로그아웃 되었습니다.");
    navigate("/");
  };

  return (
    <>
      {location.pathname === "/" ? (
        <Login />
      ) : (
        <div className={cx("container")}>
          <div className={cx("inner")}>
            <ScrollToTop />
            <div className={cx("inner")}>
              <Sidebar list={list} pathName={location?.pathname} />
              <div className={cx("content")}>
                <Header
                  currentTitle={currentTitle}
                  user={user}
                  handleLogout={handleLogout}
                />
                <div className={cx("content_box")}>{children}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
